import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserCustomerUpdateSelectorDialog from "@/v2-backoffice-client/user/customer/update/UserCustomerUpdateSelectorDialog"

export type UserCustomerUpdateSelectorDialogMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  user: UserFragment
}

function UserCustomerUpdateSelectorDialogMenuItem(
  props: UserCustomerUpdateSelectorDialogMenuItemProps,
) {
  const { user, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="users-alt"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update Customer"}
      </ActionMenu.Item>

      <UserCustomerUpdateSelectorDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        user={user}
      />
    </>
  )
}

export default UserCustomerUpdateSelectorDialogMenuItem
